import React from "react";
import { get } from "react-hook-form";
import MyLabel from "./MyLabel";

const MyNumber = ({
  title,
  name,
  register,
  errors,
  setValue,
  placeholder,
  required,
  min,
  max,
  disabled,
  pattern,
  patternMsg,
  readonly = false,
  type = "text",   // 👈 ADD THIS
}) => {
  const error = get(errors, name);

  return (
    <div className="form-group">
      <MyLabel name={name} title={title} required={required} />

      <div className="form-control-wrap">
        <input
          type={type}   // 👈 dynamic type
          placeholder={placeholder}
          id={name}
          min={type === "number" ? min : undefined}   // 👈 number min
          max={type === "number" ? max : undefined}   // 👈 number max
          {...register(name, {
            required: required
              ? {
                  value: true,
                  message: `${title || name} is required`,
                }
              : false,

            // 👇 Number validation
            ...(type === "number" && {
              valueAsNumber: true,
              min: min
                ? {
                    value: min,
                    message: `${title || name} must be at least ${min}`,
                  }
                : undefined,
              max: max
                ? {
                    value: max,
                    message: `${title || name} must be at most ${max}`,
                  }
                : undefined,
            }),

            // 👇 Text validation
            ...(type !== "number" && {
              pattern: pattern
                ? {
                    value: pattern,
                    message: patternMsg,
                  }
                : undefined,
              minLength: min
                ? {
                    value: min,
                    message: `${title || name} must be at least ${min} characters`,
                  }
                : undefined,
              maxLength: max
                ? {
                    value: max,
                    message: `${title || name} must be at most ${max} characters`,
                  }
                : undefined,
            }),
          })}
          className={`form-control ${error ? "is-invalid" : ""}`}
          onChange={(e) => {
            setValue(
              name,
              type === "number" ? Number(e.target.value) : e.target.value,
              { shouldValidate: true }
            );
          }}
          readOnly={readonly}
          disabled={disabled}
        />

        {error && (
          <span
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {error.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MyNumber;
